module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7xwe0"))).then(() => parcelRequire('1iHdE'));